import { type BackoffOptions } from 'exponential-backoff';

export const BACKOFF_OPTIONS: BackoffOptions & { numOfAttempts: number } = {
  numOfAttempts: 3,
  startingDelay: 1000,
  timeMultiple: 2,
  jitter: 'full',
  retry(error, attemptNumber) {
    // eslint-disable-next-line no-console
    console.error(
      error,
      `Will retry ${attemptNumber} of ${this.numOfAttempts}`,
    );

    return attemptNumber < this.numOfAttempts;
  },
};
